import React, { useState } from 'react';
import '../../styles/vendeurs/VendeurLogin.css';
import { Eye, EyeOff } from 'lucide-react'; // ✅ Import des icônes
import { useNavigate } from 'react-router-dom';
import { post } from '../../services/api';

function VendeurLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [erreur, setErreur] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !motDePasse) {
      setErreur("Veuillez remplir tous les champs.");
      return;
    }

    try {
        const res = await post('/vendeurs/login', { email, motDePasse });

      localStorage.setItem('vendeurConnecte', JSON.stringify(res.data));
      alert("Connexion réussie !");
      navigate("/vendeur/produits"); // ✅ Redirection vers la bonne page
    } catch (err) {
      setErreur(err.response?.data?.message || "Erreur de connexion.");
    }
  };

  return (
    <div className="vendeur-login-container">
      <div className="login-header">
        <img src="/logo-tantsaha.png" alt="logo" className="logo-tantsaha" />
        <h1 className="site-title">Tsenan'ny Tantsaha</h1>
        <h2>Connexion Vendeur</h2>
      </div>

      {erreur && <div className="erreur-global">{erreur}</div>}

      <form onSubmit={handleLogin}>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label>Mot de passe:</label>
        <div className="password-wrapper">
          <input
            type={showPassword ? 'text' : 'password'}
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
            required
          />
          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </span>
        </div>

        <button type="submit">Se connecter</button>

        <p className="register-link">
          Vous n'avez pas encore de compte ?{' '}
          <a href="/vendeur/inscription">Créer un compte</a>
        </p>
      </form>
    </div>
  );
}

export default VendeurLogin;
